/**
 * Component Registry for Prosper 207
 * 
 * Inherits from @vibesites-haven-realty-capital/theme-blue-haven and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-haven-realty-capital/theme-blue-haven/registry';
import DiscoverAmenities from './components/DiscoverAmenities';
import PropertyOverview from './components/PropertyOverview';
import PinnedCallouts from './components/PinnedCallouts';
import Header from './components/Header';
import ContactForm from './components/ContactForm';
import PreferredEmployerBenefits from './components/PreferredEmployerBenefits';
import Footer from './components/Footer';
import SitemapContent from './components/SitemapContent';
import AmenitiesFeatures from './components/AmenitiesFeatures';
import AmenitiesList from './components/AmenitiesList';
import Hero from './components/Hero';
import HeroImageBG from './components/HeroImageBG';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Example: Override the Footer with a custom component
  // Footer: Footer,
  DiscoverAmenities,
  PropertyOverview,
  PinnedCallouts,
  Header,
  ContactForm,
  PreferredEmployerBenefits,
  Footer,
  SitemapContent,
  AmenitiesFeatures,
  AmenitiesList,
  Hero,
  HeroImageBG,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
